/**
 * 旧サイトのサイズ表は 1枚ずつ iframe で読み込まれていて、表の見出しにある
 * タブ（規格サイズ / オーダーサイズ(2枚建) / オーダーサイズ(4枚建)）を押すと
 * **iframe の中だけ**が差し替わった。ページ全体は動かない。
 *
 * 移行で iframe を外したため、タブが素のリンクになりページ遷移してしまう。
 * ここでタブのクリックを横取りして、表の中身だけを入れ替える。
 *
 * - 対象は `.legacy-doc` の中にある `/pages/legacy-size-table-*` へのリンクだけ。
 *   商品リンク（旧サイトで target="_top" だったもの）は素通しで遷移させる
 * - 取得先ページの `<style>` は `.legacy-doc ...` という広いセレクタなので、
 *   そのまま差し込むと同じページの他の表を壊す。コンテナの id で包んでから入れる
 * - fetch に失敗したら既定の遷移に任せる（JS が無い環境でもリンクとして機能する）
 */
(() => {
  const PAGE_PREFIX = '/pages/legacy-size-table-';
  const cache = new Map();
  let seq = 0;

  const scopeCss = (css, id) => css.replace(/\.legacy-doc/g, `:where(#${id}) .legacy-doc`);

  const ensureId = (el) => {
    if (!el.id) el.id = `legacy-doc-${++seq}`;
    return el.id;
  };

  const fetchDoc = async (url) => {
    if (cache.has(url)) return cache.get(url);
    const res = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
    if (!res.ok) throw new Error(`${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    cache.set(url, doc);
    return doc;
  };

  const swap = async (container, url) => {
    const doc = await fetchDoc(url);
    const source = doc.querySelector('.legacy-doc');
    if (!source) throw new Error('legacy-doc not found');

    const id = ensureId(container);
    const styles = [...doc.querySelectorAll('.page-body-content style, .legacy-doc style')]
      .map((node) => scopeCss(node.textContent || '', id))
      .join('');

    container.innerHTML = source.innerHTML;
    if (styles) {
      const style = document.createElement('style');
      style.dataset.legacySizeTableTabs = '';
      style.textContent = styles;
      container.prepend(style);
    }
    container.dataset.legacySrc = url;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`a[href^="${PAGE_PREFIX}"]`);
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    // 移行時に付いた target="_blank" は旧サイトには無かった（タブは iframe 内で開く）。
    // 別タブに飛ばさず、その場で差し替える
    link.removeAttribute('target');

    const container = link.closest('.legacy-doc');
    if (!container) return;

    event.preventDefault();
    swap(container, link.getAttribute('href')).catch(() => {
      window.location.href = link.href;
    });
  });
})();
